export enum RoomForms {
  Update = 'UpdateRoomAvailability',
  UnlockDoor = 'UnlockDoor',
  RequestDatabase = 'RequestDatabase',
  IdentifyThing = 'IdentifyThing',
}
